export var AllergyFdbConceptTypes;
(function (AllergyFdbConceptTypes) {
    AllergyFdbConceptTypes["INGREDIENT"] = "Ingredient";
    AllergyFdbConceptTypes["ALLERGEN_GROUP"] = "AllergenGroup";
    AllergyFdbConceptTypes["DRUG_NAME"] = "DrugName";
})(AllergyFdbConceptTypes || (AllergyFdbConceptTypes = {}));
export var ConditionEducationPresetLinkSources;
(function (ConditionEducationPresetLinkSources) {
    ConditionEducationPresetLinkSources["WOLTERS_KLUWER"] = "wolters-kluwer";
    ConditionEducationPresetLinkSources["HEYDOCTOR"] = "heydoctor";
})(ConditionEducationPresetLinkSources || (ConditionEducationPresetLinkSources = {}));
export var DrugMonographIdentifierTypes;
(function (DrugMonographIdentifierTypes) {
    DrugMonographIdentifierTypes["NDC"] = "ndc";
    DrugMonographIdentifierTypes["RXCUI"] = "rxcui";
    DrugMonographIdentifierTypes["DEFAULT"] = "default";
})(DrugMonographIdentifierTypes || (DrugMonographIdentifierTypes = {}));
export var EducationFormats;
(function (EducationFormats) {
    EducationFormats["HTML"] = "html";
    EducationFormats["MARKDOWN"] = "markdown";
})(EducationFormats || (EducationFormats = {}));
export var EducationSources;
(function (EducationSources) {
    EducationSources["WOLTERS_KLUWER"] = "wolters-kluwer";
    EducationSources["HEYDOCTOR"] = "heydoctor";
})(EducationSources || (EducationSources = {}));
export var GoodrxCouponAttributionSources;
(function (GoodrxCouponAttributionSources) {
    GoodrxCouponAttributionSources["SMS"] = "sms";
    GoodrxCouponAttributionSources["EMAIL"] = "email";
    GoodrxCouponAttributionSources["E_SCRIPT"] = "e-script";
    GoodrxCouponAttributionSources["COUPON_PAGE"] = "coupon-page";
})(GoodrxCouponAttributionSources || (GoodrxCouponAttributionSources = {}));
export var OfficeHourDayOfWeeks;
(function (OfficeHourDayOfWeeks) {
    OfficeHourDayOfWeeks["SUNDAY"] = "Sunday";
    OfficeHourDayOfWeeks["MONDAY"] = "Monday";
    OfficeHourDayOfWeeks["TUESDAY"] = "Tuesday";
    OfficeHourDayOfWeeks["WEDNESDAY"] = "Wednesday";
    OfficeHourDayOfWeeks["THURSDAY"] = "Thursday";
    OfficeHourDayOfWeeks["FRIDAY"] = "Friday";
    OfficeHourDayOfWeeks["SATURDAY"] = "Saturday";
})(OfficeHourDayOfWeeks || (OfficeHourDayOfWeeks = {}));
export var PatientAssignmentReleaseTypes;
(function (PatientAssignmentReleaseTypes) {
    PatientAssignmentReleaseTypes["STAFF_LOGOUT"] = "staff_logout";
    PatientAssignmentReleaseTypes["STAFF_INACTIVE"] = "staff_inactive";
    PatientAssignmentReleaseTypes["MANUAL_RELEASE"] = "manual_release";
    PatientAssignmentReleaseTypes["STALE_ASSIGNMENT"] = "stale_assignment";
    PatientAssignmentReleaseTypes["ASSIGNMENT_LIMIT_EXCEEDED"] = "assignment_limit_exceeded";
    PatientAssignmentReleaseTypes["WHEEL_CONSULT_UNASSIGNED"] = "wheel_consult_unassigned";
})(PatientAssignmentReleaseTypes || (PatientAssignmentReleaseTypes = {}));
export var PhoneSessionStatuses;
(function (PhoneSessionStatuses) {
    PhoneSessionStatuses["REJECTED"] = "rejected";
    PhoneSessionStatuses["COMPLETED"] = "completed";
    PhoneSessionStatuses["FAILED"] = "failed";
    PhoneSessionStatuses["ACTIVE"] = "active";
    PhoneSessionStatuses["PENDING"] = "pending";
})(PhoneSessionStatuses || (PhoneSessionStatuses = {}));
export var PrescriptionDeliveryStatuses;
(function (PrescriptionDeliveryStatuses) {
    PrescriptionDeliveryStatuses["AWAITING_SHIPMENT"] = "awaiting_shipment";
    PrescriptionDeliveryStatuses["PENDING"] = "pending";
    PrescriptionDeliveryStatuses["UPCOMING"] = "upcoming";
    PrescriptionDeliveryStatuses["DELIVERED"] = "delivered";
    PrescriptionDeliveryStatuses["CANCELLED"] = "cancelled";
    PrescriptionDeliveryStatuses["PROCESSING"] = "processing";
    PrescriptionDeliveryStatuses["IN_TRANSIT"] = "in_transit";
    PrescriptionDeliveryStatuses["ERROR_VENDOR"] = "error_vendor";
    PrescriptionDeliveryStatuses["ERROR_PAYMENT"] = "error_payment";
    PrescriptionDeliveryStatuses["REPLACED"] = "replaced";
})(PrescriptionDeliveryStatuses || (PrescriptionDeliveryStatuses = {}));
export var ProviderNetworks;
(function (ProviderNetworks) {
    ProviderNetworks["HEYDOCTOR"] = "heydoctor";
    ProviderNetworks["WHEEL"] = "wheel";
})(ProviderNetworks || (ProviderNetworks = {}));
export var ScheduledMessageServiceTypes;
(function (ScheduledMessageServiceTypes) {
    ScheduledMessageServiceTypes["ALL"] = "all";
    ScheduledMessageServiceTypes["ASYNC"] = "async";
    ScheduledMessageServiceTypes["VIDEO"] = "video";
    ScheduledMessageServiceTypes["PHONE"] = "phone";
})(ScheduledMessageServiceTypes || (ScheduledMessageServiceTypes = {}));
export var ServiceStateTypes;
(function (ServiceStateTypes) {
    ServiceStateTypes["ASYNC"] = "async";
    ServiceStateTypes["VIDEO"] = "video";
    ServiceStateTypes["PHONE"] = "phone";
})(ServiceStateTypes || (ServiceStateTypes = {}));
export var UserAllergyStatuses;
(function (UserAllergyStatuses) {
    UserAllergyStatuses["ACTIVE"] = "active";
    UserAllergyStatuses["INACTIVE"] = "inactive";
})(UserAllergyStatuses || (UserAllergyStatuses = {}));
export var UserAllergyFdbConceptTypes;
(function (UserAllergyFdbConceptTypes) {
    UserAllergyFdbConceptTypes["INGREDIENT"] = "Ingredient";
    UserAllergyFdbConceptTypes["ALLERGEN_GROUP"] = "AllergenGroup";
    UserAllergyFdbConceptTypes["DRUG_NAME"] = "DrugName";
})(UserAllergyFdbConceptTypes || (UserAllergyFdbConceptTypes = {}));
export var UserAllergyStates;
(function (UserAllergyStates) {
    UserAllergyStates["UNCONFIRMED"] = "unconfirmed";
    UserAllergyStates["CONFIRMED"] = "confirmed";
    UserAllergyStates["REFUTED"] = "refuted";
    UserAllergyStates["ENTERED_IN_ERROR"] = "entered_in_error";
})(UserAllergyStates || (UserAllergyStates = {}));
export var UserConditionStatuses;
(function (UserConditionStatuses) {
    UserConditionStatuses["ACTIVE"] = "active";
    UserConditionStatuses["INACTIVE"] = "inactive";
})(UserConditionStatuses || (UserConditionStatuses = {}));
export var UserConditionStates;
(function (UserConditionStates) {
    UserConditionStates["UNCONFIRMED"] = "unconfirmed";
    UserConditionStates["PROVISIONAL"] = "provisional";
    UserConditionStates["DIFFERENTIAL"] = "differential";
    UserConditionStates["CONFIRMED"] = "confirmed";
    UserConditionStates["REFUTED"] = "refuted";
    UserConditionStates["ENTERED_IN_ERROR"] = "entered_in_error";
})(UserConditionStates || (UserConditionStates = {}));
export var UserConditionsUserMedicationRelationships;
(function (UserConditionsUserMedicationRelationships) {
    UserConditionsUserMedicationRelationships["ASSIGNED"] = "assigned";
    UserConditionsUserMedicationRelationships["LINKED"] = "linked";
})(UserConditionsUserMedicationRelationships || (UserConditionsUserMedicationRelationships = {}));
export var UserMedicalEventTypes;
(function (UserMedicalEventTypes) {
    UserMedicalEventTypes["HOSPITALIZATION"] = "hospitalization";
    UserMedicalEventTypes["SURGERY"] = "surgery";
})(UserMedicalEventTypes || (UserMedicalEventTypes = {}));
export var UserMedicalEventStates;
(function (UserMedicalEventStates) {
    UserMedicalEventStates["UNCONFIRMED"] = "unconfirmed";
    UserMedicalEventStates["PROVISIONAL"] = "provisional";
    UserMedicalEventStates["DIFFERENTIAL"] = "differential";
    UserMedicalEventStates["CONFIRMED"] = "confirmed";
    UserMedicalEventStates["REFUTED"] = "refuted";
    UserMedicalEventStates["ENTERED_IN_ERROR"] = "entered_in_error";
})(UserMedicalEventStates || (UserMedicalEventStates = {}));
export var UserMedicationStatuses;
(function (UserMedicationStatuses) {
    UserMedicationStatuses["ACTIVE"] = "active";
    UserMedicationStatuses["INACTIVE"] = "inactive";
})(UserMedicationStatuses || (UserMedicationStatuses = {}));
export var UserMedicationStates;
(function (UserMedicationStates) {
    UserMedicationStates["ACTIVE"] = "active";
    UserMedicationStates["COMPLETED"] = "completed";
    UserMedicationStates["ENTERED_IN_ERROR"] = "entered_in_error";
    UserMedicationStates["INTENDED"] = "intended";
    UserMedicationStates["STOPPED"] = "stopped";
    UserMedicationStates["ON_HOLD"] = "on_hold";
    UserMedicationStates["UNKNOWN"] = "unknown";
    UserMedicationStates["NOT_TAKEN"] = "not_taken";
})(UserMedicationStates || (UserMedicationStates = {}));
export var UserNotificationStatuses;
(function (UserNotificationStatuses) {
    UserNotificationStatuses["ENABLED"] = "enabled";
    UserNotificationStatuses["DISABLED"] = "disabled";
    UserNotificationStatuses["BLACKLISTED"] = "blacklisted";
})(UserNotificationStatuses || (UserNotificationStatuses = {}));
export var VideoSessionStatuses;
(function (VideoSessionStatuses) {
    VideoSessionStatuses["OPEN"] = "open";
    VideoSessionStatuses["CLOSED"] = "closed";
    VideoSessionStatuses["WAITING"] = "waiting";
    VideoSessionStatuses["NOTIFY"] = "notify";
    VideoSessionStatuses["ACTIVE"] = "active";
    VideoSessionStatuses["REVIEW"] = "review";
    VideoSessionStatuses["BACKGROUND_NOTIFY"] = "background_notify";
    VideoSessionStatuses["APPROVED"] = "approved";
    VideoSessionStatuses["REJECTED"] = "rejected";
})(VideoSessionStatuses || (VideoSessionStatuses = {}));
export var VisitPhotoSources;
(function (VisitPhotoSources) {
    VisitPhotoSources["INTAKE_TASK"] = "intake_task";
    VisitPhotoSources["PROVIDER_REQUEST"] = "provider_request";
})(VisitPhotoSources || (VisitPhotoSources = {}));
export var VisitPrescriptionStatuses;
(function (VisitPrescriptionStatuses) {
    VisitPrescriptionStatuses["SENT"] = "sent";
    VisitPrescriptionStatuses["WRITTEN"] = "written";
    VisitPrescriptionStatuses["TRANSMITTING"] = "transmitting";
    VisitPrescriptionStatuses["ERROR_PHARMACY"] = "error_pharmacy";
    VisitPrescriptionStatuses["READY_TO_TRANSMIT"] = "ready_to_transmit";
    VisitPrescriptionStatuses["ERROR_CLEARINGHOUSE"] = "error_clearinghouse";
    VisitPrescriptionStatuses["ABANDONED"] = "abandoned";
})(VisitPrescriptionStatuses || (VisitPrescriptionStatuses = {}));
export var VisitPrescriptionPharmacyTypes;
(function (VisitPrescriptionPharmacyTypes) {
    VisitPrescriptionPharmacyTypes["PICKUP"] = "pickup";
    VisitPrescriptionPharmacyTypes["DELIVERY"] = "delivery";
})(VisitPrescriptionPharmacyTypes || (VisitPrescriptionPharmacyTypes = {}));
export var WheelNetworkConsultStatuses;
(function (WheelNetworkConsultStatuses) {
    WheelNetworkConsultStatuses["REQUESTED"] = "requested";
    WheelNetworkConsultStatuses["STARTED"] = "started";
    WheelNetworkConsultStatuses["CANCELED"] = "canceled";
    WheelNetworkConsultStatuses["COMPLETED"] = "completed";
    WheelNetworkConsultStatuses["DEFERRED"] = "deferred";
})(WheelNetworkConsultStatuses || (WheelNetworkConsultStatuses = {}));
//# sourceMappingURL=schema.js.map